import { useCallback, useMemo, useState } from 'react';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { useQuery } from 'react-query';
import { Menu, Modal, Spin, Switch, message } from 'antd';

//import { TextInput } from 'components/form-control';
import { SearchIcon, XCircleIcon } from 'components/icons';
import { CustomPagination } from 'components/pagination';
import Table from 'components/table';
import { GetListCompanyParamsType } from 'services/api-external-user.type';
import { FilterValue, SorterResult } from 'antd/lib/table/interface';
import { renderSorterOrder } from 'components/table/table.const';
import { NoDataTable } from 'components/no-data-table';
import { useHistory, useLocation } from 'react-router-dom';
import { useParseParams } from 'hooks/use-params';
import { pushParamHandle } from 'modules/user-management/external-user/company/company.const';
import { UserCompanyType } from 'modules/user-management/external-user/company/company-user-modal/company-user-modal.const';
//import { isNil } from 'utils/helper';
import moment from 'moment';
import axiosClient from 'utils/axios-client';
import { TextInput } from 'components/form-control';
import { isNil } from 'utils/helper';

import './style.module.scss';
import SortingArrow from 'components/sorting-arrow';
import { CommonButton } from 'components/common-button';
import { EditItemModal } from '../edit-item-modal';
import { RowActionMenu, RowActionMenuProps } from 'modules/user-management/external-user/company/row-action-menu';
import dayjs from 'dayjs';
import ImportByTemplateModal from 'components/modal/import-by-template-modal';
import { ImportRoleDto, regRoleName } from './roles.const';
import { arrayToCsv } from './tools';
import { RolePermissionModal } from '../role-permission';
import { ObjectRolesModal } from '../object-roles';
import { EditRolePermissionTableModal } from '../edit-role-permission-table-modal';
import { crmPermissionList, crmRoleList } from './crm.const';

async function verifyImportData(rows: string[][], dtos: ImportRoleDto[] | null = null) {
  // console.log(rows[0]);
  if (rows[0].slice(0, 5).join() !== 'table,name,display_name,short_name,description') {
    return { result: false, message: 'header fail, ' + rows[0] };
  }
  if (rows.length < 2) {
    return { result: false, message: 'empty data' };
  }

  var cnt = 0;

  for (var i = 1; i < rows.length; i++) {
    //console.log(rows);
    var row = rows[i];

    if (row[0] !== 'roles') continue;

    if (!row[1].match(regRoleName)) {
      //console.log(row);
      return { result: false, line: i + 1, message: 'key name fail: ' + row };
    }

    if (dtos) {
      dtos.push({ table: row[0], name: row[1], display_name: row[2], short_name: row[3], description: row[4] });
    }

    cnt++;
  }

  if (cnt < 1) {
    return { result: false, message: 'empty data for table \'roles\'' };
  }

  return { result: true };
}

async function importData(rows: string[][]) {
  var dtos: ImportRoleDto[] = [];

  var r = await verifyImportData(rows, dtos);
  if (!r.result)
    return r;

  // console.log(dtos);
  try {
    var res = await axiosClient.post('/roles/import', { list: dtos.filter(row => row.table === 'roles').map((v) => ({ ...v, table: undefined })) });
    if (res?.data.success) {
      return { result: true, message: 'Import success, add ' + res.data.add + ', update ' + res.data.update + ', skip ' + res.data.skip + '.' };
    }
    else {
      return { result: false, message: JSON.stringify(res).slice(0, 255) };
    }
  }
  catch (ex: any) {
    //console.log(ex);
    return { result: false, message: '' + ex };
  }
}

const ACTION_LABEL = {
  EDIT: 'Edit',
  ROLE_PERMISSION: 'Role_Permission',
  OBJECT_ROLES: 'Object_Roles',
  DELETE: 'Delete',

  EDIT_CRM_ROLE: 'Edit CRM Role',
};

function ActionMenu({ row, className, action, ...props }: RowActionMenuProps) {
  const menu = (
    <Menu className={className} style={{ width: 200 }}>
      <Menu.Item key='edit roles' onClick={() => { action(ACTION_LABEL.EDIT, row); }}>Edit</Menu.Item>
      <Menu.Item key='role-permission for role' onClick={() => { action(ACTION_LABEL.ROLE_PERMISSION, row); }}>Permissions Relationship</Menu.Item>
      <Menu.Divider />
      <Menu.Item key='object-roles for role' onClick={() => { action(ACTION_LABEL.OBJECT_ROLES, row); }}>Objects Relationship</Menu.Item>
      <Menu.Divider />
      <Menu.Item key='delte roles' onClick={() => { action(ACTION_LABEL.DELETE, row); }}>Delete</Menu.Item>
    </Menu>
  );
  return <RowActionMenu {...{ row, className, action, ...props, menu }} />;
}

function ViewActionMenu({ row, className, action, ...props }: RowActionMenuProps) {
  const menu = (
    <Menu className={className} style={{ width: 200 }}>
      <Menu.Item key='Edit CRM Role' onClick={() => { action(ACTION_LABEL.EDIT_CRM_ROLE, null); }}>CRM Regulatory User Roles</Menu.Item>
    </Menu>
  );
  return <RowActionMenu {...{ row, className, action, ...props, menu }} />;
}

export default function Roles() {
  const history = useHistory();
  const location = useLocation();

  const { pageSize, page, search, sortOrder, sortBy, tabKey, action } = useParseParams();

  const [valueSearch, setValueSearch] = useState<string>(search);

  const [isItemEditing, setIsItemEditing] = useState(false);
  const [isOpenImportPopup, setOpenImportPopup] = useState<boolean>(false);
  const [isOpenRolePermissionModal, setOpenRolePermissionModal] = useState<boolean>(false);
  const [isOpenObjectRolesModal, setOpenObjectRolesModal] = useState<boolean>(false);
  const [isOpenEditCrmRoleModal, setOpenEditCrmRoleModal] = useState<boolean>(false);

  const setParamHandle = useCallback(
    (data: GetListCompanyParamsType) => {
      pushParamHandle(
        location.pathname,
        {
          page: page ?? 1,
          pageSize: pageSize ?? 50,
          search,
          sortOrder: sortOrder ?? 'desc',
          sortBy: sortBy ?? 'id',
          ...data,
        },
        history,
      );
    },
    [history, location.pathname, page, pageSize, search, sortBy, sortOrder],
  );

  const [editItemArgs, setEditItemArgs] = useState<any>({
    title: '',
    values: undefined,
    onOK: null,
  });

  /*
  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValueSearch(e.target.value);
    setTimeout(() => {
      setParamHandle({ search: e.target.value, tabKey });
    }, 700);
  };
  */

  const getRolesList = (params: any) => {
    return axiosClient.get('/roles', {
      params: {
        ...params,
        sortOrder: params.sortOrder || 'desc',
        sortBy: params.sortBy || 'id',
        pageSize: params?.pageSize ?? 50,
      },
    }).then((res) => {
      if (res.data) {
        return res.data;
      } else {
        return {};
      }
    });
  };

  //console.log([location.pathname, pageSize, page, search, sortOrder, sortBy, roleIds, tabKey]);

  const {
    data: listRolesData,
    isLoading: isListRolesLoading,
    refetch: refetchList,
  } = useQuery(
    [
      'getListRoles',
      {
        pageSize,
        page,
        //status,
        search,
        sortBy,
        sortOrder,
        action,
      },
    ], () => {
      return getRolesList({
        pageSize,
        page,
        status: undefined,  //urlStatus !== 'active,disabled' ? urlStatus : undefined,
        search: search?.trim(),
        sortBy,
        sortOrder,
        action,
      });
    });

  const onChangeTable = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<UserCompanyType>[] | SorterResult<any>,
  ) => {
    setParamHandle({
      sortBy: (sorter as SorterResult<UserCompanyType>).field as string,
      sortOrder: renderSorterOrder((sorter as SorterResult<UserCompanyType>).order as string),
      tabKey,
    });
  };

  const renderTitle = (title: string, sortingFor?: string, tooltip?: string) => (
    <div className="renderTitle" key={title}>
      <div className="title">{title}</div>
      <SortingArrow order={sortOrder} orderBy={sortBy} sortingFor={sortingFor} />
    </div>
  );

  const columns: ColumnsType<UserCompanyType> = [
    {
      align: 'left',
      title: renderTitle('ID', 'id'),
      dataIndex: 'id',
      key: 'id',
      width: 80,
      sorter: true,
      //ellipsis: true,
    },
    {
      align: 'left',
      title: renderTitle('Name', 'name'),
      dataIndex: 'name',
      key: 'name',
      width: 160,
      // ellipsis: true,
      sorter: true,
    },
    {
      align: 'left',
      title: 'Display Name',
      dataIndex: 'display_name',
      key: 'display_name',
      width: 200,
      ellipsis: true,
      // render: (_, data: any) => (data.receiver_name ? (data.receiver_name + ' / ') : '') + data.receiver_list,
    },
    {
      align: 'left',
      title: 'Short Name',
      dataIndex: 'short_name',
      key: 'short_name',
      width: 120,
      ellipsis: true,
    },
    {
      align: 'left',
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: 200,
      ellipsis: true,
    },
    {
      align: 'left',
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      //sorter: true,
      ellipsis: true,
      render: (_, data: any) => {
        return (
          <div>{isNil(data.created_at) ? '-' : moment(data.created_at).format('YYYY-MM-DD HH:mm:ss')}</div>
        );
      },
    },
    {
      align: 'left',
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 150,
      //sorter: true,
      ellipsis: true,
      render: (_, data: any) => {
        return (
          <div>{isNil(data.updated_at) ? '-' : moment(data.updated_at).format('YYYY-MM-DD HH:mm:ss')}</div>
        );
      },
    },
    {
      title: 'Action',
      dataIndex: 'rolesAction',
      key: 'rolesAction',
      width: 80,
      align: 'center',
      fixed: 'right',

      render: (_, data: UserCompanyType) => {
        return (
          <ActionMenu row={data} className={'actionMenu'} action={onRolesAction} />
        );
      },

    },
  ];

  const ClearFilters = () => {
    setValueSearch('');
    setParamHandle({ page: 1, pageSize: 50, search: undefined, tabKey });
  };

  const onChangePage = (page: number, pageSize: number) => {
    setParamHandle({ page, pageSize, tabKey, action });
  };

  const totalResult = useMemo(() => {
    return listRolesData?.total ?? 0;
  }, [listRolesData?.total]);

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValueSearch(e.target.value);
    setTimeout(() => {
      setParamHandle({ tabKey, search: e.target.value, page: 1 });
    }, 700);
  };

  const onAddRoleOk = (values: any) => {
    // console.log(values);
    axiosClient.post('/roles', {
      name: values.keyName,
      display_name: values.displayName,
      short_name: values.shortName,
      description: values.description,
    }).then((res) => {
      // console.log(res);
      message.success('Success to create a role');
      refetchList();
    }).catch((ex) => {
      // console.log(ex);
      message.error('Error: ' + (ex?.response?.data?.message || ex));
    });
  };

  const onAddRoles = () => {
    setEditItemArgs({
      title: 'Add Role',
      values: {
        keyName: '',
        displayName: '',
        shortName: '',
        description: '',
      },
      onModalOK: onAddRoleOk,
      keyNamePattern: regRoleName,
    });
    setIsItemEditing(true);
    // console.log('open add dlg');
  };

  const onEditRoleOk = (values: any) => {
    // console.log(values);
    axiosClient.put('/roles/' + values.id, {
      display_name: values.displayName,
      short_name: values.shortName,
      description: values.description,
    }).then((res) => {
      // console.log(res);
      message.success('Success to update a role');
      refetchList();
    }).catch((ex) => {
      // console.log(ex);
      message.error('Error: ' + (ex?.response?.data?.message || ex));
    });
  };

  const handleEditRoles = (row: any) => {
    setEditItemArgs({
      title: 'Edit Role',
      values: {
        id: row.id,
        keyName: row.name,
        displayName: row.display_name,
        shortName: row.short_name,
        description: row.description,
      },
      onModalOK: onEditRoleOk,
      keyNamePattern: regRoleName,
    });
    setIsItemEditing(true);
    // console.log('open add dlg');
  };

  const handleDeleteRoles = (row: any) => {
    var value: any = '';
    var modal = Modal.confirm({
      title: 'Confirm Deleting',
      content: <p>To confirm the deleting of role <span style={{ color: 'green' }}>{row.name}</span>,
        please type or paste the role's name below.<br />
        <br />
        The role &nbsp;
        <input onChange={(evt) => {
          value = evt.target.value;
          modal.update({ okButtonProps: { disabled: value !== row.name && value !== 'skip for batch' } });
        }} />
        &nbsp; will be deleted.
      </p>,
      width: 600,
      okButtonProps: { disabled: true },
      closable: true,
      maskClosable: true,
      onOk: () => {
        // console.log(value);
        axiosClient.delete('/roles/' + row.id).then((res) => {
          // console.log(res);
          message.success('Success to delete a role');
          refetchList();
        }).catch((ex) => {
          // console.log(ex);
          message.error('Error: ' + (ex?.response?.data?.message || ex));
        });

      },
    });

  };

  const [rolePermissionModalArgs, setRolePermissionModalArgs] = useState<any>({
    modalKey: 'RolePermissionModal-from-role',
    open: true,
    setModalVisible: setOpenRolePermissionModal,
  });

  const [objectRolesModalArgs, setObjectRolesModalArgs] = useState<any>({
    modalKey: 'ObjectRolesModal-from-role',
    open: true,
    setModalVisible: setOpenObjectRolesModal,
  });

  const handleRolePermission = (row: any) => {
    setRolePermissionModalArgs({
      ...rolePermissionModalArgs,
      title: 'Permissions for role [' + row.name + ']',
      role_id: row.id,
      role_name: row.name,
      permission_id: '',
      permission_name: '',
    });
    setOpenRolePermissionModal(true);
  };

  const handleObjectRoles = (row: any) => {
    setObjectRolesModalArgs({
      ...objectRolesModalArgs,
      title: 'Objects for Role [' + row.name + ']',
      role_id: row.id,
      role_name: row.name,
      object_type: '',
      object_id: '',
      object_name: '',
    });
    setOpenObjectRolesModal(true);
  };

  const [editRolePermissionTableModalArgs, setEditRolePermissionTableModalArgs] = useState<any>({
    modalKey: 'editCrmRole',
    open: true,
    setModalVisible: setOpenEditCrmRoleModal,
  });

  const handleEditCrmRole = () => {
    setEditRolePermissionTableModalArgs({
      ...editRolePermissionTableModalArgs,
      modalKey: 'editCrmRole' + (new Date()).getTime(),
      title: 'Edit CRM Regulatory User Roles',
      rolePrefix: 'CRM:',
      roleList: crmRoleList,
      permissionPrefix: 'crm:',
      permissionList: crmPermissionList,
      width: 500,
      permissionWidth: 120,
      roleWidth: 60,
    });
    setOpenEditCrmRoleModal(true);
  };

  async function onRolesAction(label: string, row: any) {
    if (label === ACTION_LABEL.EDIT) handleEditRoles(row);
    else if (label === ACTION_LABEL.ROLE_PERMISSION) handleRolePermission(row);
    else if (label === ACTION_LABEL.OBJECT_ROLES) handleObjectRoles(row);
    else if (label === ACTION_LABEL.DELETE) handleDeleteRoles(row);
    else if (label === ACTION_LABEL.EDIT_CRM_ROLE) handleEditCrmRole();
  }

  const onExportRoles = () => {
    const num = listRolesData.data.length || 0;
    if (!(num > 0)) {
      message.info('no role to export in current page.');
      return;
    }

    var includeRelation = false;

    Modal.confirm({
      title: 'Export Confirmation',
      content: <p>
        Please confirm to export the <b style={{ color: 'green' }}>{num}</b> role{(num > 1) ? 's' : ''}  in current page?<br />
        <br />
        <Switch onChange={(checked) => { includeRelation = checked; }} /> &nbsp; Include Role-Permission
        <br />
      </p>,
      closable: true,
      maskClosable: true,
      onOk: async () => {
        var exData = [
          ['table', 'name', 'display_name', 'short_name', 'description'],
        ];
        listRolesData.data.forEach((row: any) => {
          exData.push(['roles', row.name, row.display_name, row.short_name, row.description]);
        });

        //sort roles
        exData = [
          exData[0],
          ...exData.slice(1).sort((a, b) => {
            return a[1].localeCompare(b[1], undefined, { sensitivity: 'base' });
          }),
        ];
        const roleLen = exData.length;

        if (includeRelation) {
          try {
            let res: any = await axiosClient.post('/role-permission/queryByRoleIdList', listRolesData.data.map((v: any) => v.id));
            // console.log(res.data);
            if (res.data.length > 0) {
              exData[0].push('role_name', 'permission_name');
              res.data.forEach((row: any) => {
                exData.push(['role_permission', '', '', '', '', row.role.name, row.permission.name]);
              });
            }
          }
          catch (ex: any) {
            // console.log(ex);
            message.error('Error: ' + (ex?.response?.data?.message || ex));
            return;
          }

          //sort relation
          exData = [
            ...exData.slice(0, roleLen),
            ...exData.slice(roleLen).sort((a, b) => {
              return a[5].localeCompare(b[5], undefined, { sensitivity: 'base' }) || a[6].localeCompare(b[6], undefined, { sensitivity: 'base' });
            }),
          ];
        }

        const csvContent =
          'data:text/csv;charset=utf-8,' + arrayToCsv(exData);
        const encodedUri = encodeURI(csvContent);

        const link = document.createElement('a');
        link.href = encodedUri;
        link.download = 'roles-' + dayjs().format('YYYYMMDD-HHmmss') + '.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
    });
  };


  return (
    <>
      <div key={'RolesPanel' + tabKey}>
        <p className="filter-hub-text">Filter Roles</p>
        <div className="filter-hub-flex">
          <div className="filter-hub-options">
            <TextInput
              placeholder="Search names"
              className="input"
              inputProps={{
                onChange: onChangeInput,
                value: valueSearch,
                prefix: <SearchIcon width={20} height={20} />,
                maxLength: 255,
              }}
            />
          </div>
          <div className="filter-hub-btns" style={{ display: 'flex' }}>
            <div className="clear-filters" onClick={ClearFilters}>
              <span>Clear all filters</span>
              <XCircleIcon width={24} height={24} />
            </div>
            <CommonButton variant="link"
              key="add-roles"
              onClick={onAddRoles}
              disabled={false}
              style={{ marginLeft: '2em' }}
            >
              Add
            </CommonButton>
            <CommonButton variant="link"
              key="export-roles"
              onClick={onExportRoles}
              disabled={false}
              style={{ marginLeft: '0.5em' }}
            >
              Export
            </CommonButton>
            <CommonButton variant="link"
              key="import-roles"
              onClick={() => { setOpenImportPopup(true); }}
              disabled={false}
              style={{ marginLeft: '0.5em' }}
            >
              Import
            </CommonButton>
            <CommonButton variant="link"
              key="roles-action"
              disabled={false}
              style={{ marginLeft: '0.5em' }}
            >
              <ViewActionMenu row={{}} className={'actionMenu'} action={onRolesAction} />
            </CommonButton>
          </div>
        </div>
        {isListRolesLoading ? (
          <Spin className="spin" />
        ) : (
          <>
            {!listRolesData?.data || listRolesData?.data.length === 0 ? (
              <NoDataTable />
            ) : (
              <>
                <Table
                  rowKey={'id'}
                  columns={columns}
                  dataSource={listRolesData?.data || []}
                  pagination={false}
                  onChange={onChangeTable}
                  loading={isListRolesLoading}
                />

                <div className="pagination">
                  <div className="total-results-text">
                    Total results: <p className="total-results-number">{totalResult}</p>
                  </div>
                  <CustomPagination
                    pageSize={listRolesData?.pageSize ?? 50}
                    current={listRolesData?.page ?? 1}
                    total={totalResult}
                    onChange={onChangePage}
                    showSizeChanger={true}
                  />
                </div>
              </>
            )}
          </>
        )}

      </div>

      {isItemEditing && (
        <EditItemModal
          open={true}
          // onCancel={() => { setIsItemEditing(false); }}
          setModalVisible={setIsItemEditing}
          {...editItemArgs}
        />
      )}

      {isOpenImportPopup && (
        <ImportByTemplateModal
          title={'Setting - Import Roles'}
          verifyData={async (rows: string[][]) => await verifyImportData(rows)}
          closePopup={() => { setOpenImportPopup(false); }}
          importData={async (rows: string[][]) => {
            var ret = await importData(rows);
            await refetchList();
            return ret;
          }}
          action='upload-import-roles'
          templateName='setting-import-roles-template'
          xlsxTemplateUrl='/template/setting-import-roles-template.xlsx'
          csvTemplateUrl='/template/setting-import-roles-template.csv'
        />
      )}

      {isOpenRolePermissionModal && (
        <RolePermissionModal
          {...rolePermissionModalArgs}
        />
      )}

      {isOpenObjectRolesModal && (
        <ObjectRolesModal
          {...objectRolesModalArgs}
        />
      )}

      {isOpenEditCrmRoleModal && (
        <EditRolePermissionTableModal
          {...editRolePermissionTableModalArgs}
        />
      )}

    </>
  );
}
